module.exports = __webpack_public_path__ + "img/dash_persen.fc4f5951.png";